import Vue from "vue";
import axios from "axios";
import Router from "vue-router";

import login from "@/components/login/index";
import auth from "@/components/login/auth";
import home from "@/components/index";
import userLog from "@/components/user/userLog";
import loginLog from "@/components/user/loginLog";

import wangge from "@/components/person/wangge";
import zyjh from "@/components/person/zyjh";

import ryfp from "@/components/person/ryfp";
import bcsd from "@/components/person/bcsd";
import attdManage from "@/components/person/attdManage";
import zycx from "@/components/person/zycx";

import clzycx from "@/components/carsys/zycx";
import pbgl from "@/components/carsys/pbgl";
import zyxl from "@/components/carsys/zyxl";

import def from "@/components/kanban/abc/";
import abc from "@/components/kanban/carlook/";

import liucheng from "@/components/yhgl/liucheng";
import wodepaidan from "@/components/yhgl/wodepaidan";

import fbgg from "@/components/notice/fbgg";
import alarmNotice from "@/components/notice/alarmNotice";
import notice from "@/components/notice/notice";

import cmd from "@/components/cmd/index";
import ascAnalyse from "@/components/alarm/ascAnalyse";
import ascSelect from "@/components/alarm/ascSelect";

import base from "./base";
import event from "./event";
import locateLocus from "./locateLocus";
import pay from "./pay";
import qingyun from "./qingyun";
import report from "./report";
import rule from "./rule";
import work from "./work";
import yanghu from "./yanghu";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      name: "Login",
      path: "/login",
      component: login
    },
    {
      path: "/auth",
      component: auth
    },
    {
      path: "/home",
      component: home,
      meta: { auth: true },
      children: [
        {
          path: "/",
          redirect: "/control"
        },
        ...base,
        ...event,
        ...locateLocus,
        ...pay,
        ...qingyun,
        ...report,
        ...rule,
        ...work,
        ...yanghu,
        {
          path: "/def",
          component: def
        },

        {
          path: "/abc",
          component: abc
        },
        {
          path: "/liucheng",
          component: liucheng
        },
        {
          path: "/wodepaidan",
          component: wodepaidan
        },

        /*  {
          path: "/gaoweishenqing1",
          component: gaoweishenqing1
        },
        {
          path: "/gaoweishenqing2",
          component: gaoweishenqing2
        }, */

        {
          path: "/userLog",
          component: userLog
        },
        {
          path: "/loginLog",
          component: loginLog
        },
        {
          path: "/asc/select",
          component: ascSelect
        },
        {
          path: "/asc/analyse",
          component: ascAnalyse
        },
        {
          path: "/wangge",
          component: wangge
        },
        {
          path: "/zyjh",
          component: zyjh
        },
        {
          path: "/ryfp",
          component: ryfp
        },
        {
          path: "/bcsd",
          component: bcsd
        },
        {
          path: "/kqgl",
          component: attdManage
        },
        {
          path: "/zycx",
          component: zycx
        },

        {
          path: "/cmd",
          component: cmd
        },

        {
          path: "/clzycx",
          component: clzycx
        },

        {
          path: "/pbgl",
          component: pbgl
        },
        {
          path: "/zyxl",
          component: zyxl
        },
        {
          path: "/fbgg",
          component: fbgg
        },
        {
          path: "/alarmNotice",
          component: alarmNotice
        },
        {
          path: "/notice",
          component: notice
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    var mydata = sessionStorage.getItem(axios.plat);
    if (mydata == null || mydata == "") {
      // 已经登陆
      next({ path: "/login" });
    } else {
      next(); // 正常跳转到你设置好的页面
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js